var map = {
	"./amend.svg": "58d3",
	"./announcement.svg": "a6c2",
	"./arrow-right.svg": "6929",
	"./avatar.svg": "bec7",
	"./barging-nomination.svg": "8e36",
	"./bill-of-lading.svg": "1f04",
	"./billing-record.svg": "0901",
	"./boat-two.svg": "5d8e",
	"./boat.svg": "5017",
	"./calendar.svg": "0870",
	"./certificate-of-quality.svg": "109b",
	"./certificate-of-quantity.svg": "3429",
	"./clear.svg": "85b3",
	"./coa-link.svg": "fe15",
	"./color-logo.svg": "6b23",
	"./company.svg": "9ef7",
	"./delete.svg": "59a1",
	"./done.svg": "f7ef",
	"./edit.svg": "aa46",
	"./equipment-report.svg": "5849",
	"./excel.svg": "6599",
	"./export-data.svg": "7779",
	"./fresh-water.svg": "5c99",
	"./home.svg": "6bbe",
	"./jetty.svg": "9b43",
	"./menu-file.svg": "8717",
	"./menu-manger.svg": "6f5a",
	"./menu.svg": "bd3d",
	"./mooring-report.svg": "0f8b",
	"./pdf.svg": "f9a1",
	"./pilot-management.svg": "11ea",
	"./pilotage-planning.svg": "40e6",
	"./port-clear.svg": "e5ab",
	"./primary-boat.svg": "8ef7",
	"./psa.svg": "ae92",
	"./request.svg": "eb0f",
	"./search.svg": "8e8d",
	"./settings.svg": "3fc8",
	"./ship-vetting.svg": "458e",
	"./ship.svg": "6362",
	"./success.svg": "a8cf",
	"./system-administration.svg": "7f8f",
	"./systemlog.svg": "c898",
	"./tank.svg": "70db",
	"./upArrow.svg": "2731",
	"./upload.svg": "9d82",
	"./wave.svg": "77a3",
	"./zoom-in.svg": "2f8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";